import { SectionGroup } from '@toggle/toggle';

// We do this based on index since backend supports translations, so we can't use the title itself
export const splitSectionGroups = (sectionGroups: SectionGroup[]) => ({
  firstSectionGroup: sectionGroups.length > 0 ? [sectionGroups[0]] : [],
  otherSectionGroups: sectionGroups.slice(1),
});
